import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { FetchCoreData } from '../controllers/apirequest';

// COMPONENTS
import Navbar from "../components/Navbar";
import SpeedLimits from "../components/SpeedLimits";
import Definitions from "../components/Definitions";
import ProtectedAnimals from "../components/ProtectedAnimals";
import Footer from "../components/Footer";
import OrderBanner from '../components/OrderBanner';

interface Order {
  id: number;
  title: string;
  summary: string;
  description: string;
  isActive: boolean;
}

// HOME
export default function Home() {
    const [latestActiveOrder, setLatestActiveOrder] = useState<Order | null>(null);

    const handleError = () => {
    };

    useEffect(() => {
        const fetchLatestActiveOrder = async () => {
            await FetchCoreData(handleError, (orders: Order[]) => {
                if (orders && orders.length > 0) {
                    const activeOrders = orders.filter(order => order.isActive);
                    if (activeOrders.length > 0) {
                        setLatestActiveOrder(activeOrders[0]);
                    }
                }
            }, handleError);
        };
        fetchLatestActiveOrder();
    }, []);

    return (
        <Box sx={{ height: '100vh', overflowX: 'hidden', overflowY: 'scroll', backgroundColor: "var(--backgroundcolor1)" }}>
            <Navbar />

            {/* MAIN BODY */}
            <Box component="main" sx={{ px: 5, pb: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
                {latestActiveOrder && (
                    <Box sx={{ maxWidth: "1200px", width: "100%", mb: 3 }}>
                        <OrderBanner latestOrder={latestActiveOrder} />
                    </Box>
                )}
                <Box sx={{ maxWidth: "1200px", width: "100%" }}>
                    <SpeedLimits />
                    <ProtectedAnimals />
                    <Definitions />
                </Box>
            </Box>

            {/* FOOTER */}
            <Footer />
        </Box>
    );
};
